export const CONFIRM_CLIENT = 'CONFIRM_CLIENT';

export const RESET_CLIENT = 'RESET_CLIENT';

export const ON_LOAD = 'ON_LOAD';

export const FETCH_CLIENT_INFO = 'FETCH_CLIENT_INFO';

export const SUBMIT_CLIENT_DATA_FORM = 'client/SUBMIT_CLIENT_DATA_FORM';

export const GET_ALFA_MILES_BALANCE = 'GET_ALFA_MILES_BALANCE';
